import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { Box, Button, IconRefresh } from 'braid-design-system';
import { useCallback, useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import AnalyticsContext from 'src/analytics/AnalyticsContext';
import type { RecommendedJobsAnalytics } from 'src/analytics/adapter/recommendedJobs';

import translations from './.vocab';

const NewRecommendationButton = ({
  totalJobCount,
}: {
  totalJobCount?: number;
}) => {
  const { t } = useTranslations(translations);

  const { refreshNewRecsViewed, refreshNewRecsClicked } = useContext(
    AnalyticsContext,
  ) as RecommendedJobsAnalytics;

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      setTimeout(() => {
        refreshNewRecsViewed(String(totalJobCount || 0));
      }, 1500);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [inView]);

  const handleRefreshNewRecs = useCallback(() => {
    metrics.count('refreshNewRecsClicked');
    refreshNewRecsClicked(String(totalJobCount || 0));
    setTimeout(() => {
      location.reload();
    }, 500);
  }, [refreshNewRecsClicked, totalJobCount]);

  return (
    <Box boxShadow="medium" borderRadius="standard">
      <Button
        tone="formAccent"
        icon={<IconRefresh />}
        onClick={handleRefreshNewRecs}
        ref={ref}
      >
        {t('New Recommendations')}
      </Button>
    </Box>
  );
};

export default NewRecommendationButton;
